import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Festivals() {
  return <ImageCollectionPage title="Festivals" path="/culture/festivals" collection="culture_festivals" />;
}
